export const getCurrentScrollDepth = (
  element: HTMLElement | null,
  maxDepth = 5,
) => {
  let iteration = 0;
  let foundScrollDepth = undefined;

  while (iteration < maxDepth && !foundScrollDepth && element) {
    iteration++;
    const scrollDepth = element.getAttribute('data-scroll-target-depth');
    if (scrollDepth) {
      foundScrollDepth = scrollDepth;
    }
    element = element?.parentElement;
  }

  return foundScrollDepth ? +foundScrollDepth : 0;
};
